import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { CompanyOffice } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { AddEditServiceRegionModalComponent } from 'src/app/modals/add-edit-service-region-modal/add-edit-service-region-modal.component';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { CompanyOfficeService } from 'src/app/services/company-office.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';
import { companiesService } from 'src/app/shared/vive-api/companies.service';
import { CompanyDto } from 'src/app/shared/vive-api/vive-api-models';

@Component({
  selector: 'app-admin-client-service-regions',
  templateUrl: './admin-client-service-regions.component.html',
  styleUrls: ['./admin-client-service-regions.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientServiceRegionsComponent {
  constructor(
    private SharedDataService: SharedDataService,
    private ModalService: NgbModal,
    private CompanyOfficeService: CompanyOfficeService,
    private ToastService: ToastService
  ) {
    this.SharedDataService.listenForEvent<number>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'SetCompanyId' && typeof data === 'number') {
          this.CompanyId = data;

          Object.assign(this.suppliedGridQuery, { CompanyId: this.CompanyId });

          from(
            companiesService.findOneById({
              pathParams: { companyId: this.CompanyId }
            })
          ).subscribe({
            next: (Company) => {
              const { legalName } = Company;
              this.Company = Company;
              this.SharedDataService.sendEvent(
                'SetTitle',
                `Offices - ${legalName}`
              );
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('GetCompanyId');
  }

  CompanyId?: number;
  Company?: CompanyDto;
  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['edit', 'delete']
  };
  suppliedGridQuery: GenericObject = {
    attributes: ['id', 'CompanyId'],
    StreetAddress: {
      attributes: ['id']
    }
  };
  reloadGrid: boolean = true;

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: CompanyOffice;
  }) {
    const { id } = rowData;

    if (!id) {
      throw this.ToastService.addErrorToast(
        'Error',
        `Cannot ${action} office. No ID found.`,
        { returnError: true }
      );
    }

    if (action === 'edit') {
      this.addEdit(rowData);
    }

    if (action === 'delete') {
      const { componentInstance, result } = this.ModalService.open(
        ConfirmModalComponent,
        { centered: true, size: 'md' }
      );

      Object.assign(componentInstance, {
        displayText: 'Are you sure you want to delete this office?'
      });

      from(result).subscribe({
        next: (confirm) => {
          if (confirm) {
            this.CompanyOfficeService.deleteCompanyOffice(id).subscribe({
              next: () => {
                this.ToastService.addSuccessToast(
                  'Success',
                  'Successfully deleted trade category.'
                );
                this.reloadGrid = true;
              }
            });
          }
        }
      });
    }
  }

  addEdit(existingCompanyOffice?: CompanyOffice) {
    const { componentInstance, result } = this.ModalService.open(
      AddEditServiceRegionModalComponent,
      { centered: true, size: 'lg' }
    );
    const companyOffice = existingCompanyOffice
      ? existingCompanyOffice
      : Object.assign(new CompanyOffice({}), { CompanyId: this.CompanyId });

    Object.assign(componentInstance, {
      CompanyOffice: companyOffice,
      Company: this.Company
    });

    from(result).subscribe({
      next: () => {
        this.CompanyOfficeService.saveCompanyOffice(companyOffice).subscribe({
          next: () => {
            this.ToastService.addSuccessToast(
              'Success',
              'Successfully saved office.'
            );
            this.reloadGrid = true;
          }
        });
      }
    });
  }
}
